/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Score_ReliabilityInputs */

const en_directory_score_reliability = /** @type {(inputs: Directory_Score_ReliabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reliability`)
};

const zh_directory_score_reliability = /** @type {(inputs: Directory_Score_ReliabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稳定可信度`)
};

/**
* | output |
* | --- |
* | "Reliability" |
*
* @param {Directory_Score_ReliabilityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_score_reliability = /** @type {((inputs?: Directory_Score_ReliabilityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Score_ReliabilityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_score_reliability(inputs)
	return zh_directory_score_reliability(inputs)
});
export { directory_score_reliability as "directory.score.reliability" }